"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends3 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactBootstrap = require("react-bootstrap");

var _Prefill = _interopRequireDefault(require("./Fields/Prefill")); // import AdvancedProperties from './AdvancedProperties';


var DateProperties = function DateProperties(_ref) {
  var question = _ref.question,
      setQuestion = _ref.setQuestion;
  var dateField = window.pdfFormConfigObject.prefill[11];

  var handlePrefill = function handlePrefill(targetName, targetValue) {
    var _extends2;

    setQuestion((0, _extends3["default"])({}, question, (_extends2 = {}, _extends2[targetName] = targetValue, _extends2)));
  };

  return (
    /*#__PURE__*/
    _react["default"].createElement(_react["default"].Fragment, null,
    /*#__PURE__*/
    _react["default"].createElement(_reactBootstrap.Nav.Item, null,
    /*#__PURE__*/
    _react["default"].createElement(_Prefill["default"], {
      prefill: question.prefill,
      selectOptions: dateField,
      onChange: handlePrefill
    })))
  );
};

DateProperties.propTypes = process.env.NODE_ENV !== "production" ? {
  // eslint-disable-next-line react/forbid-prop-types
  question: _propTypes["default"].objectOf(_propTypes["default"].any).isRequired,
  setQuestion: _propTypes["default"].func.isRequired // errorMessages: propTypes.bool.isRequired,

} : {};

var _default = exports["default"] = DateProperties;